'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAudiotrack = function MdAudiotrack(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5h11.6v5h-6.6v18.4h-0.1c-0.4 3.7-3.6 6.6-7.4 6.6-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5c0.9 0 1.7 0.2 2.5 0.5v-15.5z' })
        )
    );
};

exports.default = MdAudiotrack;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/audiotrack.js
// module id = 1213
// module chunks = 168707334958949